/**
 * Effective project lifecycle status (matches badge logic in ProjectsListView / ProjectDetailsView).
 * @param {{ status?: string, startDate?: string|Date, endDate?: string|Date, isDeleted?: boolean } | null | undefined} project
 * @returns {"archived"|"done"|"upcoming"|"in_progress"}
 */
export function getEffectiveProjectStatus(project) {
  if (!project) return "in_progress";
  if (project.status === "archived" || project.isDeleted) return "archived";
  if (project.status === "done") return "done";
  if (project.status === "upcoming") return "upcoming";
  if (project.status === "in_progress") return "in_progress";

  const now = new Date();
  const start = project.startDate ? new Date(project.startDate) : null;
  const end = project.endDate ? new Date(project.endDate) : null;
  if (end && end < now) return "done";
  if (start && start > now) return "upcoming";
  return "in_progress";
}
